import { useTranslations } from 'next-intl';
import {
  MergedPriceAndAvailabilityResponse,
  CommonPriceAvailabilityResponse
} from 'services/dealerPriceAvailability/types';
import CoreDepositTooltip from './core-deposit-tooltip';
import CoreDepositMobileDrawer from './core-deposit-mobile-drawer';
import cx from 'classnames';
import styles from '../price.module.scss';
import {
  checkIsRiyal,
  getRiyalFormattedPrice
} from 'app/[lang]/[esite]/utils/paymentUtils';

interface DiscountPrice {
  price: MergedPriceAndAvailabilityResponse | CommonPriceAvailabilityResponse;
  isCoreDepositMobileDrawer?: boolean;
  isProductOverview: boolean;
  currency: string;
  isMobile?: boolean;
  isRTL?: boolean;
  currencyLdFeatureFlag?: boolean;
}

const DiscountPrice = ({
  price,
  isCoreDepositMobileDrawer = false,
  isProductOverview = true,
  currency = '',
  isMobile = false,
  isRTL = false,
  currencyLdFeatureFlag = false
}) => {
  const t = useTranslations();
  const showDiscountPrice = price?.unitPrice !== price?.discountedPrice;
  const saudiCurrencySymbol = currencyLdFeatureFlag && checkIsRiyal(currency);
  return (
    <>
      {showDiscountPrice &&
        isProductOverview &&
        (saudiCurrencySymbol ? (
          getRiyalFormattedPrice({
            price: price?.unitPrice,
            priceWrapperClasses: cx(
              'm-0 text-decoration-line-through px-1',
              styles['gray-text'],
              {
                ' cat-u-theme-typography-footnote': isMobile
              }
            ),
            isRTL: isRTL,
            size: 'sm'
          })
        ) : (
          <p
            className={cx(
              'm-0 text-decoration-line-through',
              styles['gray-text'],
              {
                ' cat-u-theme-typography-footnote': isMobile
              }
            )}
          >
            {`${price?.unitPrice}`} {t('ITEM_EA_ABB')}
          </p>
        ))}
      {!!price?.coreCharges && (
        <>
          {isCoreDepositMobileDrawer ? (
            <CoreDepositMobileDrawer />
          ) : (
            <CoreDepositTooltip />
          )}
          <p
            className={cx(
              isMobile
                ? 'cat-u-theme-typography-footnote m-0'
                : `m-0 ${styles['gray-text']}`
            )}
          >
            {`${price?.coreCharges} ${isProductOverview ? t('ITEM_EA_ABB') : currency}`}
          </p>
        </>
      )}
    </>
  );
};

export default DiscountPrice;
